import * as React from 'react';
import { ProductPriceView } from 'common/components/product-price-view';
import { getPriceParts } from 'utils/price-parts';
import { css } from 'linaria';
import { getLocale } from 'utils';

export namespace ContentBlocks {
  export interface PriceViewProps {
    price: number;
    currencySlug: string;
    onClick: () => void;
  }

  export const PriceView: React.FC<PriceViewProps> = ({ price, currencySlug, onClick }) => {
    const locale = getLocale();
    const parts = getPriceParts({ price, currencySlug, locale });

    return <ProductPriceView onClick={onClick} unit={null} variant="subtitle" {...parts} />;
  };

  const aStyle = css`
    color: unset;
  `;

  export const LinkWrapper: React.FC<{ href: string } & React.HTMLAttributes<HTMLElement>> = ({
    href,
    children,
    ...htmlProps
  }) => (
    <a className={aStyle} href={href} {...htmlProps}>
      {children}
    </a>
  );
}
